import { useGetApiV1ClassroomdisciplineSharedClassStudents } from '@/shared/api/generated';
import { mapDropdownOptions, useDebouncedFilter } from '@/shared/ui/molecules/LookupAutocomplete';

/**
 * Busca de turmas por texto (debounce + mínimo de 3 caracteres), opcionalmente
 * filtrada por curso, para o autocomplete de turma do modal "Adicionar Turma".
 * Consome o lookup `classroomdiscipline/shared/class-students` do Kubb — mesmo
 * endpoint usado por `grade-attendance-config` (`useClassSearchDropdown`),
 * duplicado aqui por regra de FSD (features não se importam lateralmente).
 *
 * @param filter - Texto digitado no campo (default `''`).
 * @param courseId - Restringe a busca ao curso selecionado, quando informado.
 * @returns `{ options, isLoading, isQuerySuccess }`.
 */
export function useTurmaSearchDropdown(filter = '', courseId?: number) {
  const { debouncedFilter, isReady } = useDebouncedFilter(filter);

  const { data, isLoading, isSuccess } = useGetApiV1ClassroomdisciplineSharedClassStudents(
    isReady
      ? { Search: debouncedFilter, ...(courseId !== undefined ? { CourseId: courseId } : {}) }
      : undefined,
    { query: { enabled: isReady } },
  );

  return { options: mapDropdownOptions(data), isLoading, isQuerySuccess: isSuccess } as const;
}
